import { Items as ItemsIcon } from '@cheqroom/icons';
import { FC } from 'react';

import { Info } from '../../../Info';
import { useInfoT } from '../../../Info/Info.context';
import { useKitInfoContext } from '../../KitInfo.context';

/**
 * How many items are in the kit, as "3 items". It adds up `itemQuantities`, because a bulk item counts once per unit it
 * has in the kit and `items.length` would count it once. Nothing is drawn when the kit did not load its quantities.
 */
export const Items: FC = () => {
	const { kit } = useKitInfoContext();
	const t = useInfoT('kit-info');

	if (!kit.itemQuantities) return null;

	const count = Object.values(kit.itemQuantities).reduce((total, quantity) => total + quantity, 0);

	return <Info icon={ItemsIcon} text={t('items', { count })} />;
};
